// extracted by mini-css-extract-plugin
export default {"labelColor":"#211d4e","titleColor":"#5a567b","gradientColor":"linear-gradient(90deg, #3adebb 0%, #00aee9 100%)","primaryColor":"#219b8e","cardTitle":"_audiometry_cardTitle__F-SeV"};